<section class="success-overlay">
  <app-basic-header-layout
    class="success-overlay__header"
    [logo]="logoName"
    [logoAlt]="'loading_screen.header.logo' | translate"
  ></app-basic-header-layout>

  <article class="success-overlay__content">
    <picture>
      <source [media]="mdScreenSize" [srcset]="desktopBackgroundImage" />
      <img
        class="success-overlay__content__background"
        [src]="mobileBackgroundImage"
        alt=""
      />
    </picture>

    <header class="success-overlay__content__header">
      <div class="spinner mx-auto my-8" *ngIf="loadingStatus"></div>
      <picture *ngIf="!loadingStatus">
        <source [media]="mdScreenSize" [srcset]="media" />
        <img
          class="success-overlay__content__header__image"
          [src]="media"
          alt=""
        />
      </picture>

      <h2 class="success-overlay__content__header__title title-3">
        {{ title }}
      </h2>
    </header>

    <div class="success-overlay__content__description">
      {{ description }}
    </div>

    <footer
      class="success-overlay__content__footer"
      *ngIf="status === successStatusEnum.SUCCESS"
    >
      <ng-content></ng-content>
    </footer>
  </article>
</section>
